import {SoloIntroPanel} from "@/scenes.ui/solo-intro-panel";

import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import Sprite = Phaser.GameObjects.Sprite;
import SpriteUtils from "@/utils/sprite-utils";

export class PromoSoloPanel extends SoloIntroPanel {

    private lighting!: Sprite;

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, subtitle: string, atlasKey: string | undefined,
                iconKey: string, blockFirstText: string, blockSecondText: string, onAcceptCallback: () => unknown) {
        super(scene, canvas, title, subtitle, atlasKey, iconKey, blockFirstText, blockSecondText, onAcceptCallback);
    }

    protected preInit(scene: Scene, canvas: HTMLCanvasElement): void {
        this.lighting = SpriteUtils.addSprite(scene, 0, 0, Keys.OFFER_LIGHT_BACK, undefined, 4.6).setAlpha(0);
        this.add(this.lighting);

        this.scene!.tweens.add({
            targets: this.lighting,
            alpha: 1,
            duration: 500
        });

        this.scene!.tweens.add({
            targets: this.lighting,
            angle: 360,
            duration: 90000,
            loop: -1,
        });
    }

    protected afterIconInit(scene: Scene, icon: Sprite) {
        scene.load.image('gems_chest', 'assets/chest/silverChest.png');

        scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            icon.setTexture('gems_chest');
            SpriteUtils.scale(icon, 0.7);
        });
        scene.load.start();
    }

    protected preClose(): void {
        this.lighting.setVisible(false);
    }
}
